/**
 * Lightweight ULID-ish generator (Crockford 32, time + randomness).
 * Suitable for local-IDs only — server issues canonical ULIDs.
 */
const CROCKFORD = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";

function encode(value: number, length: number): string {
  let out = "";
  for (let i = length - 1; i >= 0; i--) {
    const mod = value % 32;
    out = CROCKFORD[mod] + out;
    value = (value - mod) / 32;
  }
  return out;
}

export function localId(): string {
  const time = encode(Date.now(), 10);
  let randomness = "";
  const rand = new Uint8Array(10);
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    crypto.getRandomValues(rand);
  } else {
    for (let i = 0; i < 10; i++) rand[i] = Math.floor(Math.random() * 256);
  }
  for (let i = 0; i < 10; i++) {
    randomness += CROCKFORD[rand[i] % 32];
  }
  return `local_${time}${randomness}`;
}

export function isLocalId(id: string): boolean {
  return id.startsWith("local_");
}
